import {svgIconWrapper} from '../svg-icon-wrapper';

import WPFormsRegular from './wpforms-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <WPFormsRegular {...rest} />;
}

SvgComponent.iconName = 'wpFormsRegular';

export const WPFormsRegularIcon = svgIconWrapper(SvgComponent);
